import { render, staticRenderFns } from "./FencesStatusAndPopover.vue?vue&type=template&id=3aefe2d1&scoped=true&"
import script from "./FencesStatusAndPopover.vue?vue&type=script&lang=js&"
export * from "./FencesStatusAndPopover.vue?vue&type=script&lang=js&"
import style0 from "./FencesStatusAndPopover.vue?vue&type=style&index=0&id=3aefe2d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aefe2d1",
  null
  
)

export default component.exports